import { message } from 'antd';
export default {
    add_msg: (msg_str, msg_status = 'success') => {
        switch (msg_status) {
            case 'success':
                message.success(msg_str);
                break;
            case 'error':
                message.error(msg_str);
                break;
            case 'info':
                message.info(msg_str);
                break;
            case 'warning':
                message.warning(msg_str);
                break;
            case 'warn':
                message.warn(msg_str);
                break;
            case 'loading':
                message.loading(msg_str);
                break;
            default:
        }
    }
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/msgManage.jsx